import * as React from "react";
import PropTypes from "prop-types";
import GlobalStyleSheet from "./GlobalStyleSheet";
import Tappable, { simpleActiveBackgroundColor } from "./Tappable";

const buttonResetStyleSheet = `
  button.nx-components_NoStyleButton {
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      background: none;
      border: 0;
      color: inherit;
      font: inherit;
      line-height: normal;
      overflow: visible;
      padding: 0;
      margin: 0;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
  }
  button.nx-components_NoStyleButton::-moz-focus-inner {
      border: 0;
      padding: 0;
  }
`;

// A button that has all styles reset.
const NoStyleButton = ({
  onTap,
  children,
  style,
  innerRef,
  type,
  ...props
}) => {
  if (style.display === "flex") {
    throw new Error(
      "A button cannot be a flex container in Safari. Consider putting a div inside the NoStyleButton."
    );
  }

  const makeButton = (ref, additionalStyle) => (
    <button
      {...props}
      type={type}
      className={
        props.className
          ? `${props.className} nx-components_NoStyleButton`
          : "nx-components_NoStyleButton"
      }
      style={{
        ...style,
        cursor: props.onTap ? "pointer" : style.cursor,
        ...additionalStyle,
      }}
      ref={ref}
    >
      <GlobalStyleSheet
        id="nx-components_NoStyleButton"
        sheet={buttonResetStyleSheet}
      />
      {children}
    </button>
  );

  if (onTap != null) {
    return (
      <Tappable onTap={onTap}>
        {({ tapTargetRefHandler, active }) =>
          makeButton(
            (el) => {
              if (innerRef != null) {
                innerRef(el);
              }
              tapTargetRefHandler(el);
            },
            {
              backgroundColor: simpleActiveBackgroundColor(active),
            }
          )
        }
      </Tappable>
    );
  } else {
    return makeButton(innerRef, {});
  }
};
NoStyleButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  type: PropTypes.string,
  innerRef: PropTypes.func,
  onTap: PropTypes.func,
};
NoStyleButton.defaultProps = {
  style: {},
  // Browsers implicitly make all buttons "submit" if they are children of a form.
  // We want them to be "normal", but be sure to override actual submit buttons.
  type: "button",
};

export default NoStyleButton;



// WEBPACK FOOTER //
// ../nx-components/src/NoStyleButton.jsx